import type { TablerIcon } from "@tabler/icons-react";
import { forwardRef } from "react";
import { Icon } from "../Icon";

export const IconStadia: TablerIcon = forwardRef<
  SVGSVGElement,
  React.ComponentProps<TablerIcon>
>((props, ref) => {
  return (
    <Icon {...props} ref={ref}>
      <g clipPath="url(#clip0_7_45)">
        <path
          d="M1 12C1 13.4445 1.28452 14.8749 1.83733 16.2095C2.39013 17.5441 3.20038 18.7567 4.22183 19.7782C5.24327 20.7996 6.4559 21.6099 7.79048 22.1627C9.12506 22.7155 10.5555 23 12 23C13.4445 23 14.8749 22.7155 16.2095 22.1627C17.5441 21.6099 18.7567 20.7996 19.7782 19.7782C20.7996 18.7567 21.6099 17.5441 22.1627 16.2095C22.7155 14.8749 23 13.4445 23 12C23 10.5555 22.7155 9.12506 22.1627 7.79048C21.6099 6.4559 20.7996 5.24327 19.7782 4.22183C18.7567 3.20038 17.5441 2.39013 16.2095 1.83733C14.8749 1.28452 13.4445 1 12 1C10.5555 1 9.12506 1.28452 7.79048 1.83733C6.4559 2.39013 5.24327 3.20038 4.22183 4.22183C3.20038 5.24327 2.39013 6.4559 1.83733 7.79048C1.28452 9.12506 1 10.5555 1 12Z"
          stroke="black"
          strokeWidth="1.25"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.4748 19.0463L5.62138 15.9638C4.3674 15.3034 4.17913 13.5843 5.26046 12.6682L9 9.5L11.0963 13.9254C11.4575 14.688 12.5425 14.688 12.9037 13.9254L15 9.5L18.7392 11.8889C19.8669 12.6094 19.9826 14.2126 18.9701 15.0875L14.8343 18.6618C13.9002 19.4689 12.5671 19.6216 11.4748 19.0463Z"
          stroke="black"
          strokeWidth="1.25"
        />
        <path
          d="M12 4.125C13.0928 4.125 13.9243 4.51201 14.4844 5.10156C15.0491 5.6962 15.375 6.53663 15.375 7.5C15.375 7.78513 15.2784 8.25222 15.0781 8.87695C14.883 9.4854 14.6071 10.1894 14.291 10.9268C13.6591 12.4009 12.8794 13.9708 12.2949 15.1045C12.166 15.3546 11.834 15.3546 11.7051 15.1045C11.1206 13.9708 10.3409 12.4009 9.70898 10.9268C9.39287 10.1894 9.11699 9.4854 8.92188 8.87695C8.72155 8.25222 8.625 7.78513 8.625 7.5C8.625 6.53663 8.95086 5.6962 9.51562 5.10156C10.0757 4.51201 10.9072 4.125 12 4.125Z"
          stroke="black"
          strokeWidth="1.25"
        />
        <path
          d="M12 6.625C12.3452 6.625 12.625 6.90482 12.625 7.25C12.625 7.59518 12.3452 7.875 12 7.875C11.6548 7.875 11.375 7.59518 11.375 7.25C11.375 6.90482 11.6548 6.625 12 6.625Z"
          stroke="black"
          strokeWidth="1.25"
        />
      </g>
      <defs>
        <clipPath id="clip0_7_45">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </Icon>
  );
}) as TablerIcon;
